import { DateTimeISO, DuenessStringsEnum } from "shared-ts-types";
import { FlueId } from "../flue/FlueId";
import { AuditInfoDto } from "../../audit/AuditInfoDto";
import { DateTime } from "luxon";
import { QuantityDto } from "../../quantity/QuantityDto";
import { DateTimeUtils } from "shared-ts-utils-luxon";

export type SweepingId = string;

export interface SweepingDto {
  id: SweepingId;
  flueId: FlueId;
  time: DateTimeISO;
  sootingDegree: number;
  dueness: DuenessStringsEnum;
  wasteAmount?: QuantityDto;
  creosoteAmount?: QuantityDto;
  sootAmount?: QuantityDto;
  audit: AuditInfoDto;
}

export interface Sweeping {
  id: SweepingId;
  flueId: FlueId;
  time: DateTime<true>;
  sootingDegree: number;
  dueness: DuenessStringsEnum;
  wasteAmount: QuantityDto | undefined;
  creosoteAmount: QuantityDto | undefined;
  sootAmount: QuantityDto | undefined;
  ashAmount: QuantityDto | undefined;
  audit: AuditInfoDto;
  hasWasteComposition(): boolean;
  toDto(): SweepingDto;
}

export class SweepingImpl implements Sweeping {
  readonly id: string;
  readonly flueId: FlueId;
  readonly time: DateTime<true>;
  readonly sootingDegree: number;
  readonly dueness: DuenessStringsEnum;
  readonly wasteAmount: QuantityDto | undefined;
  readonly creosoteAmount: QuantityDto | undefined;
  readonly sootAmount: QuantityDto | undefined;
  readonly ashAmount: QuantityDto | undefined;
  readonly audit: AuditInfoDto;

  constructor(args: SweepingDto) {
    this.id = args.id;
    this.flueId = args.flueId;
    this.time = DateTimeUtils.fromISO(args.time);
    this.sootingDegree = args.sootingDegree;
    this.dueness = args.dueness;
    this.wasteAmount = args.wasteAmount;
    this.creosoteAmount = args.creosoteAmount;
    this.sootAmount = args.sootAmount;
    this.ashAmount =
      this.creosoteAmount != null || this.sootAmount != null
        ? {
            value:
              100 -
              (this.sootAmount?.value ?? 0) -
              (this.creosoteAmount?.value ?? 0),
            unit: "%",
          }
        : undefined;
    this.audit = args.audit;
  }

  hasWasteComposition(): boolean {
    return (
      this.ashAmount != null &&
      this.ashAmount.value != null &&
      this.creosoteAmount != null &&
      this.creosoteAmount.value != null &&
      this.sootAmount != null &&
      this.sootAmount.value != null
    );
  }

  toDto(): SweepingDto {
    return {
      id: this.id,
      flueId: this.flueId,
      time: this.time.toISO(),
      sootingDegree: this.sootingDegree,
      dueness: this.dueness,
      wasteAmount: this.wasteAmount,
      creosoteAmount: this.creosoteAmount,
      sootAmount: this.sootAmount,
      audit: this.audit,
    }
  }
}
